"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLocalUser = exports.updateUser = exports.loadUser = exports.currentUser = void 0;
var loadUser = function () {
    if (exports.currentUser) {
        return exports.currentUser;
    }
    var userData = localStorage.getItem('user');
    if (userData === null || !userData) {
        return undefined;
    }
    var objUser = JSON.parse(userData);
    if (objUser === null || !objUser) {
        return undefined;
    }
    if (!objUser.uid || objUser.uid.trim() === '') {
        return undefined;
    }
    if (!objUser.unit || objUser.unit.trim() === '') {
        return undefined;
    }
    exports.currentUser = objUser;
    return objUser;
};
exports.loadUser = loadUser;
var updateUser = function (user) {
    if (user === null || !user) {
        throw new Error('updateUser# Invalid user!');
    }
    if (!user.uid || user.uid.trim() === '') {
        throw new Error('updateUser# Invalid user uid!');
    }
    if (!user.unit || user.unit.trim() === '') {
        throw new Error('updateUser# Invalid user unit!');
    }
    exports.currentUser = user;
    localStorage.setItem('user', JSON.stringify(user));
};
exports.updateUser = updateUser;
var removeLocalUser = function () {
    exports.currentUser = undefined;
    localStorage.removeItem('user');
};
exports.removeLocalUser = removeLocalUser;
//# sourceMappingURL=UserCache.js.map